import {
  FunctionComponent,
  PropsWithChildren,
  ReactElement,
  useEffect,
} from 'react';

import { FormControl } from '@mui/material';

import BaseAutocomplete from '../../../../../../../shared/components/base-autocomplete/base-autocomplete';
import BaseRenderInput from '../../../../../../../shared/components/base-autocomplete/components/base-render-input/base-render-input';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../../../store/hooks';
import { filterReviewsByPlatform } from '../../../store/slices/slices/reviews.slice';
import { getReviewsFiltersValues } from '../../../thunks/get-reviews-filters.thunk';
import { useGetReviewFilters } from '../hooks/use-get-review-filters/use-get-review-filters.hook';
import { AllReviewsFiltersProps } from '../types/all-reviews-filters-props';
import withFilterValues from './with-filter-values';

const PlatformsDropdown: FunctionComponent<AllReviewsFiltersProps> = (
  props: PropsWithChildren<AllReviewsFiltersProps>
): ReactElement => {
  const { platforms } = useGetReviewFilters();
  const dispatch = useAppDispatch();

  const appId = useAppSelector(state => state.reviews.appId);

  useEffect(() => {
    if (appId) {
      dispatch(getReviewsFiltersValues(appId));
    }
  }, [appId]);

  const { setFieldValue, filterValues } = props;

  return (
    <FormControl
      data-testid="platforms-dropdown"
      key="platform-filter"
      classes={{
        root: 'form-control-main',
      }}
    >
      <BaseAutocomplete
        id="platform"
        freeSolo={false}
        multiple={false}
        value={filterValues?.platform || null}
        options={platforms}
        onChange={(event, value) => {
          setFieldValue('platform', value);
          dispatch(filterReviewsByPlatform(value ?? ''));
        }}
        renderInput={params => (
          <BaseRenderInput
            {...params}
            id="platform"
            label="Platform"
            name="platform"
            errors={props.errors}
            touched={props.touched}
          />
        )}
      />
    </FormControl>
  );
};

export default withFilterValues(PlatformsDropdown);
